import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Schedule from '../views/Schedule.vue'
import Credits from '../views/Credits.vue'
import Seniors from '../views/Seniors.vue'
import PastYears from '../views/PastYears.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: Schedule
  },
  {
    path: '/seniors',
    name: 'seniors',
    component: Seniors
  },
  {
    path: '/credits',
    name: 'Credits',
    component: Credits
  },
  {
    path: '/past-years',
    name: 'PastYears',
    component: PastYears
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
})

export default router
